import React from 'react';
import { isMobile } from 'react-device-detect';
import MobileDashboard from './MobileDashboard';
import Dashboard from './dashboard/dashboard';

const DashboardWrapper = () => {
  return isMobile ? <MobileDashboard /> : <Dashboard />;
};

export default DashboardWrapper; 